import UploadSlide from './UploadSlide';

export default UploadSlide;
